"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var merge_reducers_1 = require("./merge-reducers");
exports.getDefaultStorageSettings = function (itemName, storage) {
    if (storage === void 0) { storage = localStorage; }
    return ({
        itemName: itemName,
        storage: storage,
        updateStorageAfterChange: true,
        spreadActionsToOtherTabs: true,
    });
};
exports.getDefaultReducer = function (storageSettings, getModel) {
    return merge_reducers_1.mergeReducersWithStorage({
        storageSettings: storageSettings,
        reducers: [
            function (state, action) {
                if (state === void 0) { state = {}; }
                try {
                    var Model = getModel();
                    var isExternalAction = false;
                    if (storageSettings.specialActionKeyOfOtherTabsActions &&
                        action[storageSettings.specialActionKeyOfOtherTabsActions]) {
                        isExternalAction = true;
                    }
                    return Model.reducer(state, action, isExternalAction);
                }
                catch (e) {
                    return state;
                }
            },
        ],
    });
};
